// src/Components/UserList.jsx
import React from 'react';
import styles from '../Pages/UserManagement.module.css';

const UserList = React.memo(({ users, onEdit, onDelete }) => {
  
  if (!users || users.length === 0) {
    return (
      <p className={styles.emptyMessage}>No hay usuarios registrados en esta página.</p>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.userTable}>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Correo Electrónico</th>
            <th>Teléfono</th>
            <th>Rol</th>
            <th className={styles.actionsHeader}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.ID || user.id} className={styles.userTableRow}>
              <td>
                <span className={styles.userName}>{user.Name || user.name}</span>
              </td>
              <td>{user.Last_name || user.last_name || '—'}</td>
              <td>{user.Email || user.mail}</td>
              <td>{user.Number_phone || user.tel_number || '—'}</td>
              <td>{user.Rol || user.role}</td>
              <td className={styles.actionsCell}>
                <button
                  onClick={() => onEdit(user)}
                  className={styles.buttonEdit}
                >
                  Editar
                </button>
                <button
                  onClick={() => onDelete(user.ID || user.id)}
                  className={styles.buttonDeactivate}
                >
                  Desactivar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default UserList;